import { render, staticRenderFns } from "./OperaGroupDataWindow.vue?vue&type=template&id=db2fd9b0&scoped=true"
import script from "./OperaGroupDataWindow.vue?vue&type=script&lang=js"
export * from "./OperaGroupDataWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaGroupDataWindow.vue?vue&type=style&index=0&id=db2fd9b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2fd9b0",
  null
  
)

export default component.exports